import GlobalStyles, { kStyles } from 'GlobalStyles';

const styles: kStyles = {
	checkBoxButtonActive: { background: '#323dad', color: 'white' },
};

export default styles;
